import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseOnAuthStateChangeRepository } from '@/modules/auth/infra'
import type { OnAuthStateChange } from '@/modules/auth/use-cases'

export function makeOnAuthStateChange(): OnAuthStateChange {
  return new SupabaseOnAuthStateChangeRepository(makeSupabaseClient()).execute
}
